import * as React from "react";
import { forwardRef } from "react";
const SvgChevronDown = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	fill: "currentColor",
	height: "1em",
	viewBox: "0 0 24 24",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z" }));
const ForwardRef = forwardRef(SvgChevronDown);
export default ForwardRef;
